import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-fancy-page-title',
  templateUrl: './fancy-page-title.component.html',
  styleUrls: ['./fancy-page-title.component.css']
})
export class FancyPageTitleComponent implements OnInit{
  
  @Input() topTitle: string = '';
  @Input() subTitle: string = '';
  
    titledata:any;

  constructor() { }

  ngOnInit() {
    this.titledata = {
     
      toptitle : this.topTitle,
      subtitle: this.subTitle
    };
   
  }
}
